import { useState, useEffect, lazy, Suspense } from 'react';
import { Headset, X } from 'lucide-react';
const ChatWidget = lazy(() => import('./ChatWidget'));

export default function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  const [open, setOpen] = useState(false);
  const [hiddenByMenu, setHiddenByMenu] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 3000);
    const onScroll = () => setVisible(window.scrollY > 300);
    const onMenu = (e) => setHiddenByMenu(e.detail.open);
    window.addEventListener('scroll', onScroll);
    window.addEventListener('smartpos:mobile-menu', onMenu);
    return () => {
      clearTimeout(t);
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('smartpos:mobile-menu', onMenu);
    };
  }, []);

  if (!visible || hiddenByMenu) return null;

  return (
    <div className="fixed bottom-6 right-4 lg:right-6 z-50 flex flex-col items-end gap-3">
      {/* Chat widget */}
      <div className={`transition-all duration-300 ${open ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-4 pointer-events-none'}`}>
        {open && (
          <Suspense fallback={null}>
            <ChatWidget open={open} onClose={() => setOpen(false)} />
          </Suspense>
        )}
      </div>

      {/* Main chat button */}
      <button
        onClick={() => setOpen(!open)}
        className="w-14 h-14 bg-brand-blue rounded-full shadow-2xl shadow-blue-500/40 flex items-center justify-center hover:scale-110 transition-all duration-200 relative"
        aria-label={open ? 'Cerrar chat' : 'Abrir chat'}
      >
        {open ? <X size={20} className="text-white" /> : <Headset size={22} className="text-white" />}
        {!open && (
          <span aria-hidden="true" className="absolute -top-1 -right-1 w-4 h-4 bg-green-400 rounded-full border-2 border-white animate-pulse" />
        )}
      </button>
    </div>
  );
}